import { AutogenLayoutBrltlFuelSurchargeProfileList } from "./autogen/AutogenLayoutBrltlFuelSurchargeProfileList";

export class BrltlFuelSurchargeProfileList extends AutogenLayoutBrltlFuelSurchargeProfileList {
    override onLoad() {
        this.mainDataSource.search();
    }
}
